<template>
  <div class="logic-engine">
    <!-- <div class="rule-info-status-head"> -->
    <!-- <div class="rule-name-and-status"> -->
    <!-- <div class="rule-name"> -->
    <!-- {{ ruleInfo.ruleName }} -->
    <!-- </div> -->
    <!-- <a-switch
          v-model:checked="ruleState"
          :loading="status.handleRuleStateChange"
          checkedChildren="启用"
          unCheckedChildren="禁用"
          @change="handleRuleStateChange"
        /> -->
    <!-- </div> -->
    <!-- <a-button type="primary" @click="goToEbaIotSys">返回列表</a-button> -->
    <!-- </div> -->
    <div class="rule-drawing-board">
      <stencil-container />
      <div class="drawing-board">
        <div class="toolbar-container container-box">
          <div class="scale-control">
            <div class="label">缩放:</div>
            <a-slider
              v-model:value="sliderValue"
              :tooltipVisible="false"
              :max="200"
              :min="10"
              :step="10"
              @change="onSliderChange"
            />
            <div class="scale-value">{{ sliderValue }}%</div>
          </div>
          <div class="tool-list">
            <a-tooltip placement="bottom">
              <template #title>保存(Ctrl+s)</template>
              <SaveOutlined @click="save" />
            </a-tooltip>
            <a-tooltip placement="bottom">
              <template #title>调试运行(Ctrl+Shift+e)</template>
              <PlayCircleOutlined @click="runRule" />
            </a-tooltip>
            <a-tooltip placement="bottom">
              <template #title>居左(Ctrl+Shift+l)</template>
              <AlignLeftOutlined @click="alignLeft" />
            </a-tooltip>
            <a-tooltip placement="bottom">
              <template #title>居中(Ctrl+Shift+c)</template>
              <AlignCenterOutlined @click="alignCenter" />
            </a-tooltip>
            <a-tooltip placement="bottom">
              <template #title>居右(Ctrl+Shift+r)</template>
              <AlignRightOutlined @click="alignRight" />
            </a-tooltip>
            <a-tooltip placement="bottom">
              <template #title>删除(Delete)</template>
              <DeleteOutlined @click="deleteAllSelectedElement" />
            </a-tooltip>
          </div>
        </div>
        <div class="joint-paper-wrapper container-box">
          <perfect-scrollbar-container
            ref="perfectScrollbarRef"
            width="100%"
            height="100%"
          >
            <template #container>
              <div
                class="paper-scroller-background"
                :style="{
                  width: `${paperSrollerBackgroundWidth}px`,
                  height: `${paperSrollerBackgroundHeight}px`,
                }"
              >
                <div
                  id="joint-paper-container"
                  :style="{
                    width: `${paperWidth}px`,
                    height: `${paperHeight}px`,
                  }"
                ></div>
              </div>
            </template>
          </perfect-scrollbar-container>
        </div>
        <input
          type="file"
          id="fileLoader"
          style="display: none"
          @change="readFile"
        />
        <properties-form-container />
      </div>
    </div>
  </div>
</template>

<script>
import StencilContainer from "@/components/StencilContainer/index";
import PropertiesFormContainer from "@/components/PropertiesFormContainer/index";
import PerfectScrollbarContainer from "@/components/PerfectScrollbar";
import "jointjs/dist/joint.css";
import {
  SaveOutlined,
  PlayCircleOutlined,
  AlignLeftOutlined,
  AlignRightOutlined,
  AlignCenterOutlined,
  DeleteOutlined,
} from "@ant-design/icons-vue";
import key from "keymaster";
import saveAs from "file-saver";
import { ruleEngineInfo, ruleEngineUpdate, expressionCalculate } from "@/api";
import StatusHandler from "@/utils/statusHandler";
import { toRefs } from "@vue/reactivity";
import * as R from "ramda";
import { message } from "ant-design-vue";

const originalPaperSrollerBackgroundWidth = 3520, // 1920 + 800 * 2
  originalPaperSrollerBackgroundHeight = 1880, // 1080 + 400 * 2
  originalPaperWidth = 1920,
  originalPaperHeight = 1080;

const components = {
  PerfectScrollbarContainer,
  StencilContainer,
  PropertiesFormContainer,
  SaveOutlined,
  PlayCircleOutlined,
  AlignLeftOutlined,
  AlignRightOutlined,
  AlignCenterOutlined,
  DeleteOutlined,
};

export default {
  name: "App",
  components,
  data() {
    return {
      ruleInfo: {},

      paperSrollerBackgroundWidth: originalPaperSrollerBackgroundWidth,
      paperSrollerBackgroundHeight: originalPaperSrollerBackgroundHeight,
      paperWidth: originalPaperWidth,
      paperHeight: originalPaperHeight,
      sliderValue: 100,
    };
  },
  setup() {
    const statusHandler = StatusHandler();
    const { status } = toRefs(statusHandler);

    return {
      status,
      statusHandler,
    };
  },
  computed: {
    ruleState: {
      get() {
        return this.ruleInfo.status === "NORMAL";
      },
      set() {},
    },
  },
  mounted() {
    const token = new URL(window.location).searchParams.get("token");
    window.sessionStorage.setItem("token", token);
    this.init();
    this.initKeyBind();
    this.getRuleInfo();
  },
  methods: {
    handleRuleStateChange(value) {
      if (this.statusHandler.hasState("handleRuleStateChange")) return;
      this.statusHandler.addState("handleRuleStateChange");
      const params = {
        id: this.ruleInfo.id,
        status: value ? "NORMAL" : "DISABLE",
      };
      ruleEngineUpdate
        .request(params)
        .then((result) => {
          if (result.bizCode === 1) {
            const ruleInfoClone = R.clone(this.ruleInfo);
            ruleInfoClone.status = params.status;
            this.ruleInfo = ruleInfoClone;
          }
        })
        .finally(() => {
          this.statusHandler.removeState("handleRuleStateChange");
        });
    },
    getRuleInfo() {
      const url = new URL(window.location.href);
      const id = url.searchParams.get("id");
      ruleEngineInfo.request({ id }).then((result) => {
        if (result.bizCode === 1) {
          this.ruleInfo = result.data;
          if (R.is(String, result.data.logMapJson) && result.data.logMapJson) {
            try {
              const logicMapJson = JSON.parse(result.data.logMapJson);
              this.$joint.readJson(logicMapJson);
            } catch (error) {
              console.error(error);
            }
          }
        }
      });
    },
    initKeyBind() {
      key("ctrl+shift+l", () => {
        this.alignLeft();
        return false;
      });
      key("ctrl+shift+r", () => {
        this.alignRight();
        return false;
      });
      key("ctrl+shift+c", () => {
        this.alignCenter();
        return false;
      });
      key("delete", () => {
        this.deleteAllSelectedElement();
        return false;
      });
      key("ctrl+i", () => {
        this.zoomIn();
        return false;
      });
      key("ctrl+o", () => {
        this.zoomOut();
        return false;
      });
      key("ctrl+0", () => {
        this.resetZoom();
        return false;
      });
      key("ctrl+shift+e", () => {
        this.runRule();
        return false;
      });
      key("ctrl+s", () => {
        this.downloadJson();
        return false;
      });
      key("ctrl+q", () => {
        const fileLoaderDom = document.getElementById("fileLoader");
        fileLoaderDom.click();
      });
    },
    readFile(e) {
      const file = e.target.files[0];
      let reader = new FileReader();
      reader.addEventListener("load", (e) => {
        let text = e.target.result;
        this.$joint.readJson(JSON.parse(text));
      });
      reader.readAsText(file);
    },
    init() {
      this.$joint.init(
        document.getElementById("joint-paper-container")
        // "100%",
        // "100%"
      );
      this.setScrollViewCenter();
    },
    setScrollViewCenter() {
      const { paperSrollerBackgroundHeight, paperSrollerBackgroundWidth } =
        this;
      const perfectScrollbarRef = this.$refs.perfectScrollbarRef;
      const perfectScrollbarDom = perfectScrollbarRef.$el;

      perfectScrollbarRef.setScrollTop(
        paperSrollerBackgroundHeight / 2 - perfectScrollbarDom.clientHeight / 2
      );

      perfectScrollbarRef.setScrollLeft(
        paperSrollerBackgroundWidth / 2 - perfectScrollbarDom.clientWidth / 2
      );
    },
    zoomIn() {
      if (this.sliderValue <= 190) {
        this.sliderValue += 10;
        this.onSliderChange(this.sliderValue);
      }
    },
    zoomOut() {
      if (this.sliderValue >= 20) {
        this.sliderValue -= 10;
        this.onSliderChange(this.sliderValue);
      }
    },
    resetZoom() {
      if (this.sliderValue !== 100) {
        this.sliderValue = 100;
        this.onSliderChange(this.sliderValue);
      }
    },
    onSliderChange(value) {
      const perfectScrollbarRef = this.$refs.perfectScrollbarRef;
      const scale = value / 100;

      this.$joint.scale(scale);
      this.paperSrollerBackgroundWidth = originalPaperWidth * scale + 800 * 2;
      this.paperSrollerBackgroundHeight = originalPaperWidth * scale + 400 * 2;
      this.paperWidth = originalPaperWidth * scale;
      this.paperHeight = originalPaperHeight * scale;

      this.$nextTick(() => {
        perfectScrollbarRef.update();
      });
    },
    downloadJson() {
      const json = this.$joint.getJson();

      for (let i = 0; i < json.cells.length; i++) {
        if (json.cells[i].attrs.result) {
          delete json.cells[i].attrs.result.text;
        }
      }
      saveAs(
        new Blob([JSON.stringify(json)], { type: "text/plain;charset=utf-8" }),
        "test.json"
      );
    },
    save() {
      if (this.statusHandler.hasState("save")) return;
      this.statusHandler.addState("save");
      try {
        const rule = this.$joint.getRule();
        const logicMapJson = this.$joint.getJson();
        const params = {
          id: this.ruleInfo.id,
          exectionJson: JSON.stringify(rule),
          logicMapJson: JSON.stringify(logicMapJson),
        };
        ruleEngineUpdate
          .request(params)
          .then((result) => {
            if (result.bizCode === 1) {
              message.success("保存成功", 4);
            }
          })
          .finally(() => {
            this.statusHandler.removeState("save");
          });
      } catch (error) {
        message.warning(error);
        this.statusHandler.removeState("save");
      }
    },
    runRule() {
      if (this.statusHandler.hasState("runRule")) return;
      this.statusHandler.addState("runRule");
      try {
        const rule = this.$joint.getRule();
        const params = {
          ruleEngineId: this.ruleInfo.id,
          parameters: rule,
        };
        expressionCalculate
          .request(params)
          .then((result) => {
            if (result.bizCode === 1) {
              message.success("执行成功", 4);
              this.$joint.setResult(result.data);
            } else {
              message.warning(result.bizRemind, 4);
            }
          })
          .finally(() => {
            this.statusHandler.removeState("runRule");
          });
      } catch (error) {
        console.error(error);
        message.warning(error);
        this.statusHandler.removeState("runRule");
      }
    },
    alignLeft() {
      this.$joint.selectedElementAlignLeft();
    },
    alignCenter() {
      this.$joint.selectedElementAlignCenter();
    },
    alignRight() {
      this.$joint.selectedElementAlignRight();
    },
    deleteAllSelectedElement() {
      this.$joint.deleteAllSelectedElement();
    },
    goToEbaIotSys() {
      window.location.href = `${window.EbaIotFrontDomain}/app/collector/rulelistmangement`;
    },
  },
};
</script>

<style lang="less">
@import "~perfect-scrollbar/css/perfect-scrollbar.css";
@import "~ant-design-vue/dist/antd.less";
@import "./theme.less";

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
#app {
  width: 100vw;
  height: 100vh;
}
</style>

<style lang="less" scoped>
@import "./theme.less";

.logic-engine {
  width: 100%;
  height: 100%;
  padding: 16px;
  background-color: @black-bg;
  // > .rule-info-status-head {
  //   width: 100%;
  //   height: 88px;
  //   border-radius: 10px;
  //   background: #ffffff;
  //   display: flex;
  //   align-items: center;
  //   justify-content: space-between;
  //   padding: 24px;
  //   > .rule-name-and-status {
  //     display: flex;
  //     align-items: center;
  //     > .rule-name {
  //       font-size: 20px;
  //       color: rgba(0, 21, 41, 1);
  //       margin-right: 32px;
  //     }
  //   }
  // }
  > .rule-drawing-board {
    // margin-top: 24px;
    display: flex;
    width: 100%;
    height: calc(100%);
    > .drawing-board {
      margin-left: 16px;
      width: calc(100% - 200px - 16px);
      height: 100%;
    }
  }
}
</style>

<style lang="less" scoped>
@import "./theme.less";

.toolbar-container {
  width: 100%;
  height: 48px;
  // border-radius: 10px;
  display: flex;
  justify-content: space-between;
  // background-color: #ffffff;
  padding: 0 18px;
  > .scale-control {
    width: 400px;
    display: flex;
    align-items: center;
    > .label {
      font-size: 14px;
      color: #ffffff;
      width: 40px;
      margin-right: 10px;
    }
    > .ant-slider {
      width: calc(100% - 40px - 10px - 10px - 50px);
    }
    > .scale-value {
      margin-left: 10px;
      width: 50px;
      color: #ffffff;
    }
  }
  > .tool-list {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    height: 100%;
    padding-left: 10px;
    > .anticon {
      font-size: 20px;
      cursor: pointer;
      color: #ffffff;
      transition: color 0.3s;
      &:not(:last-of-type) {
        margin-right: 10px;
      }
      &:hover {
        color: @primary-color;
      }
    }
  }
}

.joint-paper-wrapper {
  width: 100%;
  height: calc(100% - 48px - 16px);
  margin-top: 16px;
  border-radius: 10px;
  // background-color: #ffffff;
  padding: 18px;
  > .scroll-view {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: auto;
  }
}

.paper-scroller-background {
  position: relative;
  background-color: @container-box-bg;
}

#joint-paper-container {
  left: 800px;
  top: 400px;
  position: absolute;
}
</style>
